// UWAGA: Wykorzystane w OPAC
import BsBaseController from './_base_controller'
import Tab from 'bootstrap/js/src/tab'

// usage:
//  btn {
//    data-controller="bs--tab"
//    aria-controls="collapseId"
//  }
// through `TabsHelper.rb`
export default class extends BsBaseController {
  _setAttributes () {
    super._setAttributes("tab")
  }

  _createBsComponent () {
    return new Tab(this.element)
  }
}
